export const COMPLIANCE_DAYS_THRESHOLD = 5;
export const HUMANIZE_DAYS_THREDHOLD = 30;
